import type Category from '../types/category';

const sortEmptyCategories = (a: Category, b: Category) => {
    if (!a.count) {
        return 1;
    }

    if (!b.count) {
        return -1;
    }

    return 0;
};

export default sortEmptyCategories;
